import { Request } from './Request';
import type { OAuthToken } from '@/data/models/OAuthToken';

export class PasswordTokenAuthenticationRequest extends Request<OAuthToken> {
  method = 'POST';
  url = '/login';

  data: {
    email?: string;
    password?: string;
    sport?: string;
  } = {
    email: undefined,
    password: undefined,
    sport: undefined,
  };
}
